import React, {Component} from "react";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {networkDeviceActions} from "../../../actions/network-device.actions";
import {connect} from "react-redux";
import NetworkDeviceTable from "./_components/NetworkDeviceTable";
import NetworkDeviceBox from "./_components/NetworkDeviceBox";
import {Link} from "react-router-dom";
import {withNamespaces} from "react-i18next";
import {Button, ButtonGroup} from "react-bootstrap";
import {claimTypes} from "../../../constants/claim.constants";
import {formatterHelper} from "../../../helpers/formatter-helper";
import NetworkDeviceTypeSwitcher from "./_components/NetworkDeviceTypeSwitcher";
import {modalActions} from "../../../actions/modal.actions";
import NetworkDeviceUpdaterForm from "./_forms/NetworkDeviceUpdaterForm";
import {deviceGroupActions} from "../../../actions/device-group.actions";

class NetworkDevicePage extends Component {

    constructor(props) {
        super(props);

        if(!localStorage.getItem('device-view')) {
            localStorage.setItem('device-view', 'list');
        }
    }

    state = {
        showOptions: false,
        viewToggle: localStorage.getItem('device-view') === 'list',
        areaList: [

        ],
        selectedDeviceType: 0,
        selectedDeviceGroup: null,
        selectedStatusType: null,
        selectedArea: null,
    };

    componentDidMount() {
        this.props.dispatch(deviceGroupActions.getDeviceGroupDropDownList());
        this.updateStore();
    }

    componentWillUnmount() {
        if(this.interval) {
            clearInterval(this.interval);
        }
    }

    updateStore = () => {
        const { dispatch, lockRefresh } = this.props;

        if(!lockRefresh) {
            dispatch(networkDeviceActions.getNetworkDeviceList());
        }
        if(!this.interval) {
            this.interval = setInterval(this.updateStore, 5000);
        }
    };

    toggleOptions = () => {
        this.setState({
            ...this.state,
            showOptions: !this.state.showOptions
        });
    };

    handleClickChangeAllDeviceDiagnosticMode = (setValue) => {
        const { dispatch } = this.props;
        dispatch(networkDeviceActions.setDiagnosticModeAllDevices(setValue));
    };

    handleChangeDeviceTypeFilter = (deviceTypeId) => {
        this.setState({
            ...this.state,
            selectedDeviceType: deviceTypeId
        })
    };

    handleChangeStatusTypeFilter = (statusValue) => {
        this.setState({
            ...this.state,
            selectedStatusType: statusValue
        });
    };

    handleChangeAreaFilter = (area) => {
        this.setState({
            ...this.state,
            selectedArea: area
        });
    }

    handleChangeDeviceGroupFilter = (deviceGroupId) => {
        this.setState({
            ...this.state,
            selectedDeviceGroup: deviceGroupId
        })
    }

    handleAgentDeviceInformation = (toggleAction) => {
        const { dispatch } = this.props;
        dispatch(networkDeviceActions.toggleAgentDeviceInfo(toggleAction))
    }

    handleOpenModalGlobalUpdateForm = () => {
        const { t, dispatch } = this.props;

        const modalProps = {
            open: true,
            title: t('global-updater'),
            large: 'lg',
            component: <NetworkDeviceUpdaterForm closeModal={() => dispatch(modalActions.hideModal())}/>,
        };

        dispatch(modalActions.showModal({
            modalProps: modalProps,
            modalType: 'formModal'
        }));
    }

    handleFilterList = () => {

    }

    render() {
        const { t, list, user } = this.props;

        const crudPermission            = user[`c_network-device.actions.crud`] || null;
        const diagnosticModePermission  = user[`c_network-device.actions.diagnostic-mode`] || null;
        const clearAllPermission        = user[`c_network-device.actions.btn-clear-all`] || null;

        const breadcrumb = [
            { value: 'network-device', path: '#' }
        ];

        const selectedAreaModel = this.state.areaList?.find((x) => x.id === this.state.selectedArea);
        const selectedDeviceGroup = this.state.selectedDeviceGroup;
        const uniqDeviceType = formatterHelper.distinctElementsFromList(list, 'deviceTypeId', 'deviceType', selectedAreaModel, selectedDeviceGroup);
        console.log(uniqDeviceType);

        return(
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <h4>{ t('network-device') }</h4>
                {/*todo actions*/}
                <div className="card">
                    <div className="card-header">
                        <div className="button-group">

                            { diagnosticModePermission === claimTypes.READ_WRITE || clearAllPermission === claimTypes.READ_WRITE ? (
                                <button className="btn btn-outline-dark" onClick={() => this.toggleOptions()}>
                                    { t('advanced-settings') } &nbsp;
                                    <i className="fas fa-angle-down"> </i>
                                </button>
                            ) : (
                                <React.Fragment/>
                            ) }

                            { crudPermission === claimTypes.READ_WRITE ? (
                                <Link to="/panel/network-device/create" className="btn btn-success float-right btn-create mt-2 mt-sm-0">
                                    <i className="fas fa-plus"> </i> &nbsp; { t('create') }
                                </Link>
                            ) : (<React.Fragment/>) }

                        </div>
                    </div>
                    <div className="card-body">

                        { !this.state.showOptions || (
                            <div  className="row">
                                { diagnosticModePermission === claimTypes.READ_WRITE ? (
                                    <div id="diagnosticModeAll" className="col-md-2">
                                        <p>{t("diagnostic-mode-all")}</p>
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => this.handleClickChangeAllDeviceDiagnosticMode(true)}
                                        > {t("on")}
                                        </button>
                                        &nbsp;
                                        <button
                                            className="btn btn-outline-secondary active"
                                            onClick={() => this.handleClickChangeAllDeviceDiagnosticMode(false)}
                                        > {t("off")}
                                        </button>
                                    </div>
                                ) : (<React.Fragment/>) }

                                { clearAllPermission === claimTypes.READ_WRITE ? (
                                    <div id="clearAllTemp" className="col-md-2">
                                        <p>{t("clear-all-temp-files")}</p>
                                        <button id="clear-temp-files" className="btn btn-warning" value="true">{t("clear-all-btn")}</button>
                                    </div>
                                ) : (<React.Fragment/>) }

                                <div id="updater" className="col-md-2">
                                    <p>{t('global-hilight-updater')}</p>
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => this.handleOpenModalGlobalUpdateForm()}
                                    > {t('global-hilight-updater-modal')}
                                    </button>
                                </div>

                                <div className="col-md-2">
                                    <h6>{ t("agent-device-info") }</h6>
                                    <ButtonGroup size="sm" className="m-2">
                                        <Button variant="primary"
                                                onClick={() => this.handleAgentDeviceInformation(true)} >
                                            { t('show') }
                                        </Button>
                                        <Button variant="outline-primary"
                                                onClick={() => this.handleAgentDeviceInformation(false)} >
                                            { t('hide') }
                                        </Button>
                                    </ButtonGroup>
                                </div>

                            </div>
                        )}

                        <div className="row my-2">
                            <div className="col-md-10">
                                <NetworkDeviceTypeSwitcher
                                    uniqDeviceType={uniqDeviceType}
                                    enabledDeviceGroup={true}
                                    enabledArea={false}
                                    networkDeviceList={list}
                                    activeElement={this.state.selectedDeviceType}
                                    areas={this.state.areaList}
                                    deviceGroupList={this.props.deviceGroups}
                                    statusActiveElement={this.state.selectedStatusType}
                                    selectedArea={this.state.selectedArea}
                                    selectedDeviceGroup={this.state.selectedDeviceGroup}
                                    onChangeDeviceType={(id) => this.handleChangeDeviceTypeFilter(id)}
                                    onChangeStatusType={(value) => this.handleChangeStatusTypeFilter(value)}
                                    onChangeArea={(area) => this.handleChangeAreaFilter(area)}
                                    onChangeDeviceGroup={(deviceGroupId) => this.handleChangeDeviceGroupFilter(deviceGroupId)}
                                />
                            </div>
                            <div className="col-md-2">
                                <div className="d-block text-right">
                                    <h6>{t('change-view')}</h6>
                                    <ButtonGroup size="sm" className="m-2">
                                        <Button variant={'outline-secondary'}
                                                active={this.state.viewToggle }
                                                onClick={() => { this.setState({...this.state, viewToggle: true }); localStorage.setItem('device-view', 'list') }}>
                                            <i className="fas fa-list" />
                                        </Button>
                                        <Button variant={'outline-secondary'}
                                                active={!this.state.viewToggle}
                                                onClick={() => { this.setState({...this.state, viewToggle: false }); localStorage.setItem('device-view', 'box') }}>
                                            <i className="fas fa-th" />
                                        </Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </div>

                        { this.state.viewToggle ?
                            (<NetworkDeviceTable
                                list={list}
                                areas={this.state.areaList}
                                selectedDeviceType={this.state.selectedDeviceType}
                                selectedStatusValue={this.state.selectedStatusType}
                                selectedArea={this.state.selectedArea}
                                selectedDeviceGroup={this.state.selectedDeviceGroup}
                            />) :
                            (<NetworkDeviceBox
                                list={list}
                                areas={this.state.areaList}
                                selectedDeviceType={this.state.selectedDeviceType}
                                selectedStatusValue={this.state.selectedStatusType}
                                selectedArea={this.state.selectedArea}
                                selectedDeviceGroup={this.state.selectedDeviceGroup}
                            />)
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { list, lockRefresh } = state.networkDeviceReducer;
    const { dropdown } = state.deviceGroupReducer;
    const { user } = state.authenticationReducer;
    return {
        list,
        user,
        lockRefresh,
        deviceGroups: dropdown,
    }
};

export default withNamespaces()(connect(mapStateToProps)(NetworkDevicePage));
